import React, { useState } from 'react';
import CotizacionPreview from './CotizacionPreview';

function CotizadorAutomatico() {
  const [activeTab, setActiveTab] = useState('lumina');
  const [activeSubtab, setActiveSubtab] = useState({
    bosko: 'cocinas',
    techos: 'sin-estructura'
  });
  const [accesorios, setAccesorios] = useState([]);
  const [accesorioCounter, setAccesorioCounter] = useState(0);

  // Estados para LUMINA
  const [luminaData, setLuminaData] = useState({
    alto: '',
    ancho: '',
    herraje: '',
    vidrio: '',
    semblanteado: false,
    instalacion: false
  });
  const [luminaResult, setLuminaResult] = useState(null);

  // Estados para BOSKO
  const [boskoData, setBoskoData] = useState({
    muebleInferior: '',
    muebleSuperior: '',
    altoBrilloMetros: '',
    puertasVidrioAncho: '',
    puertasVidrioAlto: '',
    madera: 'no',
    mesonLongitud: '',
    tipoMeson: '0',
    herrajes: 'no',
    platilleros: false,
    poceta: false,
    extractor: false,
    estufaAcero: false,
    estufaNegra: false,
    estufaVidrio: false,
    horno: false,
    griferia: false,
    shut: false,
    especiero: false
  });
  const [boskoResult, setBoskoResult] = useState(null);

  // Estados para EXTRAS
  const [extrasData, setExtrasData] = useState({
    closetAncho: '',
    closetAlto: '',
    centroLargo: '',
    puertaAncho: '',
    puertaCantidad: ''
  });
  const [extrasResult, setExtrasResult] = useState(null);

  // Estados para TECHOS
  const [techosData, setTechosData] = useState({
    sinMetros: '',
    conMetros: ''
  });
  const [techosSinResult, setTechosSinResult] = useState(null);
  const [techosConResult, setTechosConResult] = useState(null);

  // Cotización (vista previa + PDF)
  const [cotizacion, setCotizacion] = useState(null);

  const formatCurrency = (value) => {
    return '$' + Math.round(value).toLocaleString('es-CO');
  };

  const agregarAccesorio = () => {
    setAccesorios([...accesorios, { id: accesorioCounter, nombre: '', precio: '' }]);
    setAccesorioCounter(accesorioCounter + 1);
  };

  const eliminarAccesorio = (id) => {
    setAccesorios(accesorios.filter(acc => acc.id !== id));
  };

  const actualizarAccesorio = (id, field, value) => {
    setAccesorios(accesorios.map(acc =>
      acc.id === id ? { ...acc, [field]: value } : acc
    ));
  };

  const calcularLumina = () => {
    const alto = parseFloat(luminaData.alto) || 0;
    const ancho = parseFloat(luminaData.ancho) || 0;
    const herraje = parseFloat(luminaData.herraje) || 0;
    const vidrio = parseFloat(luminaData.vidrio) || 0;

    let total = 0;
    let breakdown = [];

    // Calcular herraje
    let precioHerraje = herraje;
    if (herraje > 0) {
      const herrajeTipo = herraje === 190000 ? 'Herraje Batiente' : 'Herraje Corrediza';

      if (ancho > 1.5) {
        const cmAdicionales = (ancho - 1.5) * 100;
        const incrementos = Math.ceil(cmAdicionales / 10);
        const adicional = incrementos * 10000;
        precioHerraje += adicional;
        breakdown.push({ name: herrajeTipo, price: herraje });
        breakdown.push({ name: `Incremento por ancho adicional (${cmAdicionales.toFixed(0)}cm)`, price: adicional });
      } else {
        breakdown.push({ name: herrajeTipo, price: precioHerraje });
      }
      total += precioHerraje;
    }

    // Calcular vidrio
    const areaVidrio = alto * ancho;
    if (vidrio > 0 && areaVidrio > 0) {
      const vidrioTipo = vidrio === 156000 ? 'Vidrio 6mm' : 'Vidrio de Color 6mm';
      const precioVidrio = areaVidrio * vidrio;
      breakdown.push({ name: `${vidrioTipo} (${areaVidrio.toFixed(2)}m²)`, price: precioVidrio });
      total += precioVidrio;
    }

    // Adicionales
    if (luminaData.semblanteado) {
      breakdown.push({ name: 'Semblanteado (diseño personalizado)', price: 80000 });
      total += 80000;
    }
    if (luminaData.instalacion) {
      breakdown.push({ name: 'Instalación (Bogotá)', price: 90000 });
      total += 90000;
    }

    setLuminaResult({ total, breakdown });
    if (breakdown.length > 0) setCotizacion({ breakdown, total, titulo: 'LUMINA' });
  };

  const calcularBosko = () => {
    const muebleInferior = parseFloat(boskoData.muebleInferior) || 0;
    const muebleSuperior = parseFloat(boskoData.muebleSuperior) || 0;
    const mesonLongitud = parseFloat(boskoData.mesonLongitud) || 0;
    const tipoMeson = parseFloat(boskoData.tipoMeson) || 0;

    let total = 0;
    let breakdown = [];

    // Muebles en madera
    if (boskoData.madera === 'si' && (muebleInferior > 0 || muebleSuperior > 0)) {
      const totalMetros = muebleInferior + muebleSuperior;
      const precioMuebles = totalMetros * 790000;
      breakdown.push({ name: `Muebles en madera (${totalMetros.toFixed(2)}m)`, price: precioMuebles });
      total += precioMuebles;
    }

    // Alto brillo
    const altoBrilloMetros = parseFloat(boskoData.altoBrilloMetros) || 0;
    if (altoBrilloMetros > 0) {
      const precioAltoBrillo = altoBrilloMetros * 120000;
      breakdown.push({ name: `Alto brillo (${altoBrilloMetros.toFixed(2)}m)`, price: precioAltoBrillo });
      total += precioAltoBrillo;
    }

    // Puertas en vidrio
    const puertasVidrioAncho = parseFloat(boskoData.puertasVidrioAncho) || 0;
    const puertasVidrioAlto = parseFloat(boskoData.puertasVidrioAlto) || 0;
    if (puertasVidrioAncho > 0 && puertasVidrioAlto > 0) {
      const areaPuertasVidrio = puertasVidrioAncho * puertasVidrioAlto;
      const precioPuertasVidrio = areaPuertasVidrio * 320000;
      breakdown.push({ name: `Puertas en vidrio (${puertasVidrioAncho.toFixed(2)}m × ${puertasVidrioAlto.toFixed(2)}m = ${areaPuertasVidrio.toFixed(2)}m²)`, price: precioPuertasVidrio });
      total += precioPuertasVidrio;
    }

    // Mesón
    if (tipoMeson > 0 && mesonLongitud > 0) {
      const mesonTipo = tipoMeson === 480000 ? 'Mesón en granito tonos claros' : 'Mesón en granito tonos oscuros, Quarztone y piedra sinterizada';
      const precioMeson = mesonLongitud * tipoMeson;
      breakdown.push({ name: `${mesonTipo} (${mesonLongitud.toFixed(2)}m)`, price: precioMeson });
      total += precioMeson;
    }

    // Herrajes
    if (boskoData.herrajes === 'si' && (muebleInferior > 0 || muebleSuperior > 0)) {
      const totalMetros = muebleInferior + muebleSuperior;
      const precioHerrajes = totalMetros * 100000;
      breakdown.push({ name: `Herrajes (${totalMetros.toFixed(2)}m)`, price: precioHerrajes });
      total += precioHerrajes;
    }

    // Accesorios
    if (boskoData.platilleros) { breakdown.push({ name: 'Platilleros en acero', price: 100000 }); total += 100000; }
    if (boskoData.poceta) { breakdown.push({ name: 'Poceta en acero inoxidable', price: 100000 }); total += 100000; }
    if (boskoData.extractor) { breakdown.push({ name: 'Extractor de 3 velocidades', price: 320000 }); total += 320000; }
    if (boskoData.estufaAcero) { breakdown.push({ name: 'Estufa en acero inoxidable', price: 480000 }); total += 480000; }
    if (boskoData.estufaNegra) { breakdown.push({ name: 'Estufa en acero inoxidable negra', price: 690000 }); total += 690000; }
    if (boskoData.estufaVidrio) { breakdown.push({ name: 'Estufa en vidrio templado', price: 990000 }); total += 990000; }
    if (boskoData.horno) { breakdown.push({ name: 'Horno gratinador', price: 980000 }); total += 980000; }
    if (boskoData.griferia) { breakdown.push({ name: 'Grifería económica', price: 70000 }); total += 70000; }
    if (boskoData.shut) { breakdown.push({ name: 'Shut basura doble', price: 390000 }); total += 390000; }
    if (boskoData.especiero) { breakdown.push({ name: 'Especiero', price: 290000 }); total += 290000; }

    // Accesorios personalizados
    accesorios.forEach(acc => {
      const precio = parseFloat(acc.precio) || 0;
      const nombre = acc.nombre || 'Accesorio personalizado';
      if (precio > 0) {
        breakdown.push({ name: nombre, price: precio });
        total += precio;
      }
    });

    setBoskoResult({ total, breakdown });
    if (breakdown.length > 0) setCotizacion({ breakdown, total, titulo: 'Cocina Integral BOSKO' });
  };

  const calcularExtras = () => {
    const closetAncho = parseFloat(extrasData.closetAncho) || 0;
    const closetAlto = parseFloat(extrasData.closetAlto) || 0;
    const centroLargo = parseFloat(extrasData.centroLargo) || 0;

    let total = 0;
    let breakdown = [];

    if (closetAncho > 0 && closetAlto > 0) {
      const areaCloset = closetAncho * closetAlto;
      const precioCloset = areaCloset * 750000;
      breakdown.push({ name: `Closet (${closetAncho.toFixed(2)}m × ${closetAlto.toFixed(2)}m = ${areaCloset.toFixed(2)}m²)`, price: precioCloset });
      total += precioCloset;
    }

    if (centroLargo > 0) {
      const precioCentro = centroLargo * 950000;
      breakdown.push({ name: `Centro de Entretenimiento (${centroLargo.toFixed(2)}m)`, price: precioCentro });
      total += precioCentro;
    }

    // Puertas
    const puertaAncho = parseFloat(extrasData.puertaAncho) || 0;
    const puertaCantidad = parseInt(extrasData.puertaCantidad) || 1;
    if (puertaAncho > 0) {
      let precioUnitario = 690000;
      const adicional = puertaAncho > 0.80;
      if (adicional) precioUnitario += 300000;
      const precioPuerta = precioUnitario * puertaCantidad;
      breakdown.push({ name: `Puertas (${puertaCantidad} und × ${puertaAncho.toFixed(2)}m${adicional ? ' - +$300,000 c/u por ancho > 0.80m' : ''})`, price: precioPuerta });
      total += precioPuerta;
    }

    setExtrasResult({ total, breakdown });
    if (breakdown.length > 0) setCotizacion({ breakdown, total, titulo: 'Extras BOSKO' });
  };

  const calcularTechoSin = () => {
    const metros = parseFloat(techosData.sinMetros) || 0;
    const precioPorMetro = 14700;

    if (metros > 0) {
      const total = metros * precioPorMetro;
      const laminas = metros / 1.5;
      const breakdown = [{ name: `Techo PVC sin estructura (${metros.toFixed(2)}m²)`, price: total }];
      setTechosSinResult({ total, breakdown, laminas });
      if (breakdown.length > 0) setCotizacion({ breakdown, total, titulo: 'Techo PVC sin estructura' });
    }
  };

  const calcularTechoCon = () => {
    const metros = parseFloat(techosData.conMetros) || 0;
    const precioPorMetro = 21500;

    if (metros > 0) {
      const total = metros * precioPorMetro;
      const breakdown = [{ name: `Techo PVC con estructura (${metros.toFixed(2)}m²)`, price: total }];

      const materiales = {
        laminas: (metros / 1.5).toFixed(2),
        angulos: (0.40 * metros).toFixed(2),
        omegas: (0.47 * metros).toFixed(2),
        vigueta: (0.30 * metros).toFixed(2),
        perimetral: (0.17 * metros).toFixed(2),
        tornilleria: (10 * metros).toFixed(0)
      };

      setTechosConResult({ total, breakdown, materiales });
      if (breakdown.length > 0) setCotizacion({ breakdown, total, titulo: 'Techo PVC con estructura' });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-400 p-5 relative overflow-x-hidden">
      {/* Background shapes */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute w-20 h-20 rounded-full bg-white/10 top-[20%] left-[10%] animate-pulse" />
        <div className="absolute w-30 h-30 rounded-full bg-white/10 top-[60%] right-[15%] animate-pulse" style={{ animationDelay: '2s' }} />
        <div className="absolute w-15 h-15 rounded-full bg-white/10 bottom-[20%] left-[20%] animate-pulse" style={{ animationDelay: '4s' }} />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center text-white mb-10 py-10">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-4 bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent drop-shadow-2xl">
            CLENIP GROUP
          </h1>
          <p className="text-xl md:text-3xl font-light opacity-95 tracking-wide">Cotizador automático</p>
        </div>

        {/* Vista previa de cotización + PDF */}
        <CotizacionPreview
          cotizacion={cotizacion}
          onClose={() => setCotizacion(null)}
          formatCurrency={formatCurrency}
        />

        {/* Tabs */}
        <div className="flex gap-2 mb-0 flex-wrap justify-center">
          <button
            onClick={() => setActiveTab('lumina')}
            className={`px-8 py-4 rounded-t-2xl font-semibold transition-all duration-300 border-2 border-white/20 ${
              activeTab === 'lumina' ? 'bg-gradient-to-br from-gray-500 to-gray-600 text-white scale-105 shadow-xl' : 'bg-gradient-to-br from-gray-400 to-gray-500 text-white hover:scale-105'
            }`}
          >
            LUMINA
          </button>
          <button
            onClick={() => setActiveTab('bosko')}
            className={`px-8 py-4 rounded-t-2xl font-semibold transition-all duration-300 border-2 border-white/20 ${
              activeTab === 'bosko' ? 'bg-gradient-to-br from-green-600 to-green-700 text-white scale-105 shadow-xl' : 'bg-gradient-to-br from-green-500 to-green-600 text-white hover:scale-105'
            }`}
          >
            BOSKO
          </button>
          <button
            onClick={() => setActiveTab('techos')}
            className={`px-8 py-4 rounded-t-2xl font-semibold transition-all duration-300 border-2 border-white/20 ${
              activeTab === 'techos' ? 'bg-gradient-to-br from-yellow-500 to-orange-500 text-gray-800 scale-105 shadow-xl' : 'bg-gradient-to-br from-yellow-400 to-orange-400 text-gray-800 hover:scale-105'
            }`}
          >
            TECHOS EN PVC
          </button>
        </div>

        {/* Content */}
        <div className="bg-white/95 backdrop-blur-xl p-10 rounded-b-3xl rounded-tr-3xl shadow-2xl border border-white/20">
          {/* LUMINA Tab */}
          {activeTab === 'lumina' && (
            <div className="animate-fadeIn">
              <h2 className="text-3xl font-bold text-gray-600 mb-6">LUMINA</h2>

              <div className="space-y-6">
                <div>
                  <label className="block font-semibold text-gray-700 mb-2">Alto (metros):</label>
                  <input
                    type="number"
                    step="0.01"
                    value={luminaData.alto}
                    onChange={(e) => setLuminaData({ ...luminaData, alto: e.target.value })}
                    className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none transition-all"
                    placeholder="Ingrese el alto en metros"
                  />
                </div>

                <div>
                  <label className="block font-semibold text-gray-700 mb-2">Ancho (metros):</label>
                  <input
                    type="number"
                    step="0.01"
                    value={luminaData.ancho}
                    onChange={(e) => setLuminaData({ ...luminaData, ancho: e.target.value })}
                    className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none transition-all"
                    placeholder="Ingrese el ancho en metros"
                  />
                </div>

                <div>
                  <label className="block font-semibold text-gray-700 mb-2">Tipo de Herraje:</label>
                  <select
                    value={luminaData.herraje}
                    onChange={(e) => setLuminaData({ ...luminaData, herraje: e.target.value })}
                    className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none transition-all"
                  >
                    <option value="">Seleccione una opción</option>
                    <option value="190000">Herraje Batiente ($190,000)</option>
                    <option value="170000">Herraje Corrediza ($170,000)</option>
                  </select>
                  <small className="text-gray-600 block mt-1">Precio fijo hasta 1.50m de ancho, después +$10,000 por cada 10cm adicionales</small>
                </div>

                <div>
                  <label className="block font-semibold text-gray-700 mb-2">Tipo de Vidrio:</label>
                  <select
                    value={luminaData.vidrio}
                    onChange={(e) => setLuminaData({ ...luminaData, vidrio: e.target.value })}
                    className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none transition-all"
                  >
                    <option value="">Seleccione una opción</option>
                    <option value="156000">Vidrio 6mm ($156,000/m²)</option>
                    <option value="289000">Vidrio de Color 6mm ($289,000/m²)</option>
                  </select>
                  <small className="text-gray-600 block mt-1">El precio es por metro cuadrado</small>
                </div>

                <div className="flex items-center gap-3 p-4 bg-white/60 rounded-xl border-2 border-transparent hover:border-gray-200 transition-all cursor-pointer">
                  <input
                    type="checkbox"
                    id="lumina-semblanteado"
                    checked={luminaData.semblanteado}
                    onChange={(e) => setLuminaData({ ...luminaData, semblanteado: e.target.checked })}
                    className="w-5 h-5"
                  />
                  <label htmlFor="lumina-semblanteado" className="font-medium cursor-pointer">
                    Semblanteado (diseño personalizado) - $80,000
                  </label>
                </div>

                <div className="flex items-center gap-3 p-4 bg-white/60 rounded-xl border-2 border-transparent hover:border-gray-200 transition-all cursor-pointer">
                  <input
                    type="checkbox"
                    id="lumina-instalacion"
                    checked={luminaData.instalacion}
                    onChange={(e) => setLuminaData({ ...luminaData, instalacion: e.target.checked })}
                    className="w-5 h-5"
                  />
                  <label htmlFor="lumina-instalacion" className="font-medium cursor-pointer">
                    Con instalación - $90,000 (Precio fijo a nivel Bogotá)
                  </label>
                </div>

                <button
                  onClick={calcularLumina}
                  className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 px-12 rounded-2xl font-bold text-lg hover:scale-105 transition-all shadow-lg hover:shadow-xl"
                >
                  CALCULAR PRECIO
                </button>

                {luminaResult && (
                  <div className="mt-10 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-400 text-white p-10 rounded-3xl shadow-2xl">
                    <h3 className="text-2xl font-semibold mb-4">Precio Total LUMINA</h3>
                    <div className="text-5xl font-extrabold my-6">{formatCurrency(luminaResult.total)}</div>

                    <div className="mt-6 p-5 bg-white/15 rounded-2xl">
                      <h4 className="text-xl font-semibold mb-4">Desglose de precios:</h4>
                      <div className="space-y-2">
                        {luminaResult.breakdown.map((item, idx) => (
                          <div key={idx} className="flex justify-between p-2 bg-white/10 rounded-lg">
                            <span className="text-white/90">{item.name}</span>
                            <span className="font-bold">{formatCurrency(item.price)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* BOSKO Tab */}
          {activeTab === 'bosko' && (
            <div className="animate-fadeIn">
              <h2 className="text-3xl font-bold text-green-600 mb-6">BOSKO</h2>

              {/* Subtabs */}
              <div className="flex gap-2 mb-8 p-2 bg-black/5 rounded-2xl">
                <button
                  onClick={() => setActiveSubtab({ ...activeSubtab, bosko: 'cocinas' })}
                  className={`flex-1 py-3 px-6 rounded-xl font-semibold transition-all ${
                    activeSubtab.bosko === 'cocinas' ? 'bg-white/20 shadow-lg' : 'hover:bg-white/10'
                  } text-green-700`}
                >
                  COCINAS INTEGRALES
                </button>
                <button
                  onClick={() => setActiveSubtab({ ...activeSubtab, bosko: 'extras' })}
                  className={`flex-1 py-3 px-6 rounded-xl font-semibold transition-all ${
                    activeSubtab.bosko === 'extras' ? 'bg-white/20 shadow-lg' : 'hover:bg-white/10'
                  } text-amber-800`}
                >
                  Extras BOSKO
                </button>
              </div>

              {/* Nota destacada en nube de chat */}
              <div className="relative mb-8 max-w-2xl">
                <div className="absolute -top-2 left-8 w-4 h-4 bg-amber-100 border-l-2 border-t-2 border-amber-300 rotate-45"></div>
                <div className="relative bg-amber-100 border-2 border-amber-300 rounded-2xl px-5 py-4 shadow-md flex items-start gap-3">
                  <span className="text-2xl leading-none">💬</span>
                  <p className="text-amber-900 font-semibold text-sm md:text-base">
                    Las torres, barras, muebles de baño y plafones se cobran por la medida más larga y por metro lineal.
                  </p>
                </div>
              </div>

              {activeSubtab.bosko === 'cocinas' && (
                <div className="space-y-6">
                  <h3 className="text-2xl font-bold text-green-600">Cocina Integral BOSKO</h3>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">Longitud de mueble inferior (metros):</label>
                      <input
                        type="number"
                        step="0.01"
                        value={boskoData.muebleInferior}
                        onChange={(e) => setBoskoData({ ...boskoData, muebleInferior: e.target.value })}
                        className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                        placeholder="Ingrese la longitud"
                      />
                    </div>

                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">Longitud de mueble superior (metros):</label>
                      <input
                        type="number"
                        step="0.01"
                        value={boskoData.muebleSuperior}
                        onChange={(e) => setBoskoData({ ...boskoData, muebleSuperior: e.target.value })}
                        className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                        placeholder="Ingrese la longitud"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Cantidad de metros de alto brillo (metros lineales):</label>
                    <input
                      type="number"
                      step="0.01"
                      value={boskoData.altoBrilloMetros}
                      onChange={(e) => setBoskoData({ ...boskoData, altoBrilloMetros: e.target.value })}
                      className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                      placeholder="Ingrese los metros de alto brillo"
                    />
                    <small className="text-gray-600 block mt-1">Precio: $120,000 por metro lineal</small>
                  </div>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Puertas en vidrio:</label>
                    <div className="grid md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm text-gray-600 mb-1">Ancho (metros):</label>
                        <input
                          type="number"
                          step="0.01"
                          value={boskoData.puertasVidrioAncho}
                          onChange={(e) => setBoskoData({ ...boskoData, puertasVidrioAncho: e.target.value })}
                          className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                          placeholder="Ancho"
                        />
                      </div>
                      <div>
                        <label className="block text-sm text-gray-600 mb-1">Alto (metros):</label>
                        <input
                          type="number"
                          step="0.01"
                          value={boskoData.puertasVidrioAlto}
                          onChange={(e) => setBoskoData({ ...boskoData, puertasVidrioAlto: e.target.value })}
                          className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                          placeholder="Alto"
                        />
                      </div>
                    </div>
                    <small className="text-gray-600 block mt-1">Precio: Ancho × Alto × $320,000 por metro cuadrado</small>
                  </div>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Muebles en madera:</label>
                    <select
                      value={boskoData.madera}
                      onChange={(e) => setBoskoData({ ...boskoData, madera: e.target.value })}
                      className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                    >
                      <option value="no">No</option>
                      <option value="si">Sí</option>
                    </select>
                    <small className="text-gray-600 block mt-1">Precio: $790,000 por metro lineal</small>
                  </div>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Longitud de mesón de granito (metros):</label>
                    <input
                      type="number"
                      step="0.01"
                      value={boskoData.mesonLongitud}
                      onChange={(e) => setBoskoData({ ...boskoData, mesonLongitud: e.target.value })}
                      className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                      placeholder="Ingrese la longitud del mesón"
                    />
                  </div>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Tipo de mesón:</label>
                    <select
                      value={boskoData.tipoMeson}
                      onChange={(e) => setBoskoData({ ...boskoData, tipoMeson: e.target.value })}
                      className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                    >
                      <option value="0">Sin mesón</option>
                      <option value="480000">Mesón en granito tonos claros ($480,000/m)</option>
                      <option value="690000">Mesón en granito tonos oscuros, Quarztone y piedra sinterizada ($690,000/m)</option>
                    </select>
                  </div>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Herrajes:</label>
                    <select
                      value={boskoData.herrajes}
                      onChange={(e) => setBoskoData({ ...boskoData, herrajes: e.target.value })}
                      className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-green-500 focus:outline-none transition-all"
                    >
                      <option value="no">No</option>
                      <option value="si">Sí</option>
                    </select>
                    <small className="text-gray-600 block mt-1">Precio: $100,000 por metro lineal</small>
                  </div>

                  <h4 className="text-xl font-bold text-green-600 mt-8">Accesorios adicionales:</h4>

                  {[
                    { id: 'platilleros', label: 'Platilleros en acero - $100,000' },
                    { id: 'poceta', label: 'Poceta en acero inoxidable - $100,000' }
                  ].map(item => (
                    <div key={item.id} className="flex items-center gap-3 p-4 bg-white/60 rounded-xl border-2 border-transparent hover:border-gray-200 transition-all cursor-pointer">
                      <input
                        type="checkbox"
                        id={`bosko-${item.id}`}
                        checked={boskoData[item.id]}
                        onChange={(e) => setBoskoData({ ...boskoData, [item.id]: e.target.checked })}
                        className="w-5 h-5"
                      />
                      <label htmlFor={`bosko-${item.id}`} className="font-medium cursor-pointer">{item.label}</label>
                    </div>
                  ))}

                  <h4 className="text-xl font-bold text-green-600 mt-8">Electrodomésticos:</h4>

                  {[
                    { id: 'extractor', label: 'Extractor de 3 velocidades - $320,000' },
                    { id: 'estufaAcero', label: 'Estufa en acero inoxidable - $480,000' },
                    { id: 'estufaNegra', label: 'Estufa en acero inoxidable negra - $690,000' },
                    { id: 'estufaVidrio', label: 'Estufa en vidrio templado - $990,000' },
                    { id: 'horno', label: 'Horno gratinador - $980,000' },
                    { id: 'griferia', label: 'Grifería económica - $70,000' },
                    { id: 'shut', label: 'Shut basura doble - $390,000' },
                    { id: 'especiero', label: 'Especiero - $290,000' }
                  ].map(item => (
                    <div key={item.id} className="flex items-center gap-3 p-4 bg-white/60 rounded-xl border-2 border-transparent hover:border-gray-200 transition-all cursor-pointer">
                      <input
                        type="checkbox"
                        id={`bosko-${item.id}`}
                        checked={boskoData[item.id]}
                        onChange={(e) => setBoskoData({ ...boskoData, [item.id]: e.target.checked })}
                        className="w-5 h-5"
                      />
                      <label htmlFor={`bosko-${item.id}`} className="font-medium cursor-pointer">{item.label}</label>
                    </div>
                  ))}

                  <h4 className="text-xl font-bold text-green-600 mt-8">Accesorios extras personalizados:</h4>

                  <div className="space-y-4 p-5 bg-white/50 rounded-2xl border-2 border-dashed border-gray-300">
                    {accesorios.map(acc => (
                      <div key={acc.id} className="flex gap-3 items-center p-4 bg-white/80 rounded-xl border-2 border-gray-200">
                        <input
                          type="text"
                          placeholder="Nombre del accesorio"
                          value={acc.nombre}
                          onChange={(e) => actualizarAccesorio(acc.id, 'nombre', e.target.value)}
                          className="flex-1 p-3 border border-gray-300 rounded-lg"
                        />
                        <input
                          type="number"
                          placeholder="Precio"
                          value={acc.precio}
                          onChange={(e) => actualizarAccesorio(acc.id, 'precio', e.target.value)}
                          className="w-40 p-3 border border-gray-300 rounded-lg"
                          step="1000"
                        />
                        <button
                          onClick={() => eliminarAccesorio(acc.id)}
                          className="bg-gradient-to-r from-red-500 to-red-600 text-white px-5 py-3 rounded-lg font-semibold hover:scale-105 transition-all shadow-lg"
                        >
                          Eliminar
                        </button>
                      </div>
                    ))}
                  </div>

                  <button
                    onClick={agregarAccesorio}
                    className="bg-gradient-to-r from-green-500 to-green-600 text-white py-3 px-7 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg"
                  >
                    + Agregar Accesorio
                  </button>

                  <button
                    onClick={calcularBosko}
                    className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 px-12 rounded-2xl font-bold text-lg hover:scale-105 transition-all shadow-lg hover:shadow-xl mt-8"
                  >
                    CALCULAR PRECIO
                  </button>

                  {boskoResult && (
                    <div className="mt-10 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-400 text-white p-10 rounded-3xl shadow-2xl">
                      <h3 className="text-2xl font-semibold mb-4">Precio Total BOSKO</h3>
                      <div className="text-5xl font-extrabold my-6">{formatCurrency(boskoResult.total)}</div>

                      <div className="mt-6 p-5 bg-white/15 rounded-2xl">
                        <h4 className="text-xl font-semibold mb-4">Desglose de precios:</h4>
                        <div className="space-y-2">
                          {boskoResult.breakdown.map((item, idx) => (
                            <div key={idx} className="flex justify-between p-2 bg-white/10 rounded-lg">
                              <span className="text-white/90">{item.name}</span>
                              <span className="font-bold">{formatCurrency(item.price)}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {activeSubtab.bosko === 'extras' && (
                <div className="space-y-6">
                  <h3 className="text-2xl font-bold text-amber-800">Extras BOSKO</h3>

                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">Closet - Ancho (metros):</label>
                      <input
                        type="number"
                        step="0.01"
                        value={extrasData.closetAncho}
                        onChange={(e) => setExtrasData({ ...extrasData, closetAncho: e.target.value })}
                        className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none transition-all"
                        placeholder="Ancho del closet"
                      />
                    </div>

                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">Closet - Alto (metros):</label>
                      <input
                        type="number"
                        step="0.01"
                        value={extrasData.closetAlto}
                        onChange={(e) => setExtrasData({ ...extrasData, closetAlto: e.target.value })}
                        className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none transition-all"
                        placeholder="Alto del closet"
                      />
                    </div>
                  </div>
                  <small className="text-gray-600 block">Precio: Ancho × Alto × $750,000</small>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Centro de Entretenimiento - Largo (metros):</label>
                    <input
                      type="number"
                      step="0.01"
                      value={extrasData.centroLargo}
                      onChange={(e) => setExtrasData({ ...extrasData, centroLargo: e.target.value })}
                      className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none transition-all"
                      placeholder="Largo del centro de entretenimiento"
                    />
                    <small className="text-gray-600 block mt-1">Precio: Largo × $950,000</small>
                  </div>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Puertas:</label>
                    <div className="grid md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm text-gray-600 mb-1">Ancho (metros):</label>
                        <input
                          type="number"
                          step="0.01"
                          value={extrasData.puertaAncho}
                          onChange={(e) => setExtrasData({ ...extrasData, puertaAncho: e.target.value })}
                          className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none transition-all"
                          placeholder="Ancho de la puerta"
                        />
                      </div>
                      <div>
                        <label className="block text-sm text-gray-600 mb-1">Cantidad:</label>
                        <input
                          type="number"
                          step="1"
                          min="1"
                          value={extrasData.puertaCantidad}
                          onChange={(e) => setExtrasData({ ...extrasData, puertaCantidad: e.target.value })}
                          className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-amber-500 focus:outline-none transition-all"
                          placeholder="Cantidad de puertas"
                        />
                      </div>
                    </div>
                    <small className="text-gray-600 block mt-1">Precio: $690,000 por puerta. Si el ancho supera 0.80m, se suman $300,000 adicionales. Se multiplica por la cantidad.</small>
                  </div>

                  <button
                    onClick={calcularExtras}
                    className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 px-12 rounded-2xl font-bold text-lg hover:scale-105 transition-all shadow-lg hover:shadow-xl"
                  >
                    CALCULAR PRECIO
                  </button>

                  {extrasResult && (
                    <div className="mt-10 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-400 text-white p-10 rounded-3xl shadow-2xl">
                      <h3 className="text-2xl font-semibold mb-4">Precio Total Extras BOSKO</h3>
                      <div className="text-5xl font-extrabold my-6">{formatCurrency(extrasResult.total)}</div>

                      <div className="mt-6 p-5 bg-white/15 rounded-2xl">
                        <h4 className="text-xl font-semibold mb-4">Desglose de precios:</h4>
                        <div className="space-y-2">
                          {extrasResult.breakdown.map((item, idx) => (
                            <div key={idx} className="flex justify-between p-2 bg-white/10 rounded-lg">
                              <span className="text-white/90">{item.name}</span>
                              <span className="font-bold">{formatCurrency(item.price)}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* TECHOS Tab */}
          {activeTab === 'techos' && (
            <div className="animate-fadeIn">
              <h2 className="text-3xl font-bold text-orange-600 mb-6">TECHOS EN PVC</h2>

              {/* Subtabs */}
              <div className="flex gap-2 mb-8 p-2 bg-black/5 rounded-2xl">
                <button
                  onClick={() => setActiveSubtab({ ...activeSubtab, techos: 'sin-estructura' })}
                  className={`flex-1 py-3 px-6 rounded-xl font-semibold transition-all ${
                    activeSubtab.techos === 'sin-estructura' ? 'bg-white/20 shadow-lg' : 'hover:bg-white/10'
                  } text-orange-700`}
                >
                  TECHO SIN ESTRUCTURA
                </button>
                <button
                  onClick={() => setActiveSubtab({ ...activeSubtab, techos: 'con-estructura' })}
                  className={`flex-1 py-3 px-6 rounded-xl font-semibold transition-all ${
                    activeSubtab.techos === 'con-estructura' ? 'bg-white/20 shadow-lg' : 'hover:bg-white/10'
                  } text-orange-700`}
                >
                  TECHO CON ESTRUCTURA
                </button>
              </div>

              {activeSubtab.techos === 'sin-estructura' && (
                <div className="space-y-6">
                  <h3 className="text-2xl font-bold text-orange-600">Techo Sin Estructura</h3>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Metros cuadrados:</label>
                    <input
                      type="number"
                      step="0.01"
                      value={techosData.sinMetros}
                      onChange={(e) => setTechosData({ ...techosData, sinMetros: e.target.value })}
                      className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:outline-none transition-all"
                      placeholder="Ingrese los metros cuadrados"
                    />
                    <small className="text-gray-600 block mt-1">Precio por metro: $14,700</small>
                    <small className="text-gray-600 block">Conversión: 1 lámina = 1.5 m²</small>
                  </div>

                  <button
                    onClick={calcularTechoSin}
                    className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 px-12 rounded-2xl font-bold text-lg hover:scale-105 transition-all shadow-lg hover:shadow-xl"
                  >
                    CALCULAR PRECIO
                  </button>

                  {techosSinResult && (
                    <div className="mt-10 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-400 text-white p-10 rounded-3xl shadow-2xl">
                      <h3 className="text-2xl font-semibold mb-4">Precio Total Techo Sin Estructura</h3>
                      <div className="text-5xl font-extrabold my-6">{formatCurrency(techosSinResult.total)}</div>

                      <div className="mt-6 p-5 bg-white/15 rounded-2xl">
                        <h4 className="text-xl font-semibold mb-4">Desglose de precios:</h4>
                        <div className="space-y-2">
                          {techosSinResult.breakdown.map((item, idx) => (
                            <div key={idx} className="flex justify-between p-2 bg-white/10 rounded-lg">
                              <span className="text-white/90">{item.name}</span>
                              <span className="font-bold">{formatCurrency(item.price)}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <p className="mt-4 text-lg">Láminas necesarias: <span className="font-bold">{techosSinResult.laminas.toFixed(2)}</span></p>
                    </div>
                  )}
                </div>
              )}

              {activeSubtab.techos === 'con-estructura' && (
                <div className="space-y-6">
                  <h3 className="text-2xl font-bold text-orange-600">Techo Con Estructura</h3>

                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">Metros cuadrados:</label>
                    <input
                      type="number"
                      step="0.01"
                      value={techosData.conMetros}
                      onChange={(e) => setTechosData({ ...techosData, conMetros: e.target.value })}
                      className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:outline-none transition-all"
                      placeholder="Ingrese los metros cuadrados"
                    />
                    <small className="text-gray-600 block mt-1">Precio por metro: $21,500</small>
                  </div>

                  <button
                    onClick={calcularTechoCon}
                    className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 px-12 rounded-2xl font-bold text-lg hover:scale-105 transition-all shadow-lg hover:shadow-xl"
                  >
                    CALCULAR PRECIO
                  </button>

                  {techosConResult && (
                    <div className="mt-10 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-400 text-white p-10 rounded-3xl shadow-2xl">
                      <h3 className="text-2xl font-semibold mb-4">Precio Total Techo Con Estructura</h3>
                      <div className="text-5xl font-extrabold my-6">{formatCurrency(techosConResult.total)}</div>

                      <div className="mt-6 p-5 bg-white/15 rounded-2xl">
                        <h4 className="text-xl font-semibold mb-4">Desglose de precios:</h4>
                        <div className="space-y-2">
                          {techosConResult.breakdown.map((item, idx) => (
                            <div key={idx} className="flex justify-between p-2 bg-white/10 rounded-lg">
                              <span className="text-white/90">{item.name}</span>
                              <span className="font-bold">{formatCurrency(item.price)}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="mt-6 text-left space-y-2">
                        <p className="text-lg font-semibold mb-3">Materiales necesarios:</p>
                        <p>Láminas de techo PVC: <span className="font-bold">{techosConResult.materiales.laminas}</span></p>
                        <p>Ángulos: <span className="font-bold">{techosConResult.materiales.angulos}</span></p>
                        <p>Omegas: <span className="font-bold">{techosConResult.materiales.omegas}</span></p>
                        <p>Vigueta: <span className="font-bold">{techosConResult.materiales.vigueta}</span></p>
                        <p>Perimetral (corniza): <span className="font-bold">{techosConResult.materiales.perimetral}</span></p>
                        <p>Tornillería (estructura y PVC): <span className="font-bold">{techosConResult.materiales.tornilleria}</span></p>
                      </div>
                    </div>
                  )}

                  <div className="bg-gradient-to-r from-yellow-100 to-yellow-200 border-2 border-yellow-500 p-5 rounded-2xl text-yellow-800 font-semibold shadow-lg">
                    ⚠️ ESTE CÁLCULO SOLO SIRVE PARA ÁREAS MAYORES A 15 MTS CUADRADO, ÁREAS MENORES LE HARÁ FALTA ESTRUCTURA
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out;
        }
      `}</style>
    </div>
  );
}

export default CotizadorAutomatico;
